<template>
  <div class="login" style="background-color:white">
    <div class="welcome">
      <h2>{{ $t('auth.welcome') }}</h2>
      <br>
    </div>
    <form method="post" action="/auth/login" name="login">
      <div class="form-group flex" :class="{ 'has-error': errors.has('email') }">
        <div class="input-group">
          <va-input type="text" name="email" id="email" v-model="email" required="required"  aria-required="true"  v-validate="'required'"
          :label="username"/>
        </div>
      </div>
      <div class="form-group" :class="{ 'has-error': errors.has('password') }">
        <div class="input-group">
          <va-input type="password" name="password" id="password" v-model="senha" v-on:keydown.enter="logar" required="required" aria-required="true"  v-validate="'required'"
          :label="password"/>
        </div>
      </div>
      <div style="display:flex;justify-content:center;align-items:center; margin: auto;">
      <va-checkbox
          :label="keep"
          v-model="manter"
        />
      </div>
      <div style="display:flex;justify-content:center;align-items:center; margin: 20px auto;">
        <br>
        <va-button large class="btn btn-primary  btn-block" @click="logar" type="button" @keyup.enter="logar" :disabled="errors.has('email') || errors.has('password')">
          {{  $t('auth.login') }}
        </va-button>
      </div>
    </form>
  </div>
</template>

<script>
import constantes from '@/utils/ConstantesGlobais'
import MetodosGlobais from '@/utils/MetodosGlobais'

export default {
  name: 'login',
  data () {
    return {
      email: '',
      senha: '',
      manter: true,
      redirect: '',
    }
  },
  computed: {
    keep () { return this.$t('auth.keep_logged_in') },
    username () { return this.$t('auth.usernameOrEmail') },
    password () { return this.$t('auth.password') },
    toastConfig () {
      let toastConfig = constantes.TOASTED_ERROR
      toastConfig.duration = 4000
      toastConfig.singleton = true
      return toastConfig
    },
  },
  mounted () {
    if (this.$route.query.error) {
      this.redirect = this.$route.query.redirect
      this.mostrarMensagem(this.$route.query.error)
    }
  },
  methods: {
    mostrarMensagem (mensagem) {
      this.showToast(this.$t(mensagem), this.toastConfig)
      this.$router.replace({ 'query': null })
    },
    async logar () {
      if (this.email.length > 0 && this.senha.length > 0) {
        let payload = { username: this.email, password: this.senha.replace(/'/g, ''), manter: this.manter }
        if (this.email && this.senha) {
          this.$store.dispatch('authentication/login', payload).then(
            (retorno) => {
              if (MetodosGlobais.isEmpty(this.$store.state.authentication.user) && retorno.name == 'Error') {
                this.showToast(`Erro de login: ${retorno.response.data.mensagem} (${retorno.response.status})`, constantes.TOASTED_ERROR)
              } else {
                if (this.redirect) {
                  this.$router.push(this.redirect)
                } else { this.$router.push('/sp360') }
              }
            }
          )
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.login {
  width: 21.375rem;
  @include media-breakpoint-down(md) {
    width: 100%;
    padding-right: 2rem;
    padding-left: 2rem;
    width: 21.375rem;
    .down-container {
      display: none;
    }
  }

  .welcome {
    font-family: Source Sans Pro,sans-serif !important;
    text-align: center;
    font-weight: 150;
    margin: 0.5rem;
    font-size: 2rem;
  }

  .down-container {
    margin-top: 3.125rem;
  }

}
</style>
